/*
Form: Form for users to change their password
Name: ChangePassword
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Messages } from 'primereact/messages';
import PropTypes from 'prop-types';
import MessageService from '../service/MessageService';

// Regex für die verbotenen Zeichen
const forbiddenCharsRegex = /[\\/:*"<>|]/;
const maxPwLength = 20;

export default class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.showMessage = this.showMessage.bind(this);
    this.wrapMessage = this.wrapMessage.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAbort = this.handleAbort.bind(this);
    this.state = {
      username: sessionStorage.getItem('username'),
      password: '',
      newPassword: '',
      newPasswordAgain: '',
      uuid: sessionStorage.getItem('uuid'),
      isNewPasswordValid: true,
      isNewPasswordRepetitionValid: true,
    };
    this.messageService = new MessageService();
  }

  handleChange = (e) => {
    this.setState({
      // eslint-disable-next-line comma-dangle
      [e.target.name]: e.target.value
    });
  };

    handleNewPasswordChange = (e) => {
      this.messages.clear();
      const isNewPasswordValid = this.validatePassword(e.target.value);
      this.setState({
        [e.target.name]: e.target.value, isNewPasswordValid,
      });
    };

    handleNewPasswordRepetitionChange = (e) => {
      this.messages.clear();
      const isNewPasswordRepetitionValid = this.validatePassword(e.target.value);
      this.setState({
        [e.target.name]: e.target.value, isNewPasswordRepetitionValid,
      });
    };

  handleSubmit(event) {
    // console.log('############ handleSubmit: ');
    event.preventDefault();
    if (this.validateForm()) {
      this.wrapMessage();
    }
  }

  handleAbort(event) {
    // console.log('ABORT');
    event.preventDefault();
    const { history } = this.props;
    history.push('./');
  }

  handleKeyDown(event) {
    if (event.keyCode === 13) {
      // console.log('############ submit from handleKeyDown');
      this.wrapMessage();
    }
  }

    validatePassword = (password) => {
      return !forbiddenCharsRegex.test(password) && password.length <= maxPwLength;
    }

  wrapMessage = async () => {
    const { username } = this.state;
    const { password } = this.state;
    const { newPassword } = this.state;
    const { newPasswordAgain } = this.state;
    const { uuid } = this.state;
    const textMessage = await this.messageService.postPasswordChange(
      username,
      password,
      newPassword,
      newPasswordAgain,
      uuid,
    );
    if (textMessage[0] !== '') {
      this.setState({
        password: '',
      });
      this.setState({
        newPassword: '',
      });
      this.setState({
        newPasswordAgain: '',
      });
      this.showMessage(textMessage[0], textMessage[1]);
    }
  };

  showMessage(messageDetail, messageSeverity) {
    const msg = {
      life: 5000,
      severity: messageSeverity,
      detail: messageDetail,
    };
    this.messages.show(msg);
  }

  validateForm() {
    const { password } = this.state;
    const { newPassword, isNewPasswordValid } = this.state;
    const { newPasswordAgain, isNewPasswordRepetitionValid } = this.state;
    return (
      password.length > 0
      && newPassword.length > 0
      && newPasswordAgain.length > 0
      && isNewPasswordValid && isNewPasswordRepetitionValid
    );
  }

  render() {
    const { password } = this.state;
    const { newPassword, isNewPasswordValid } = this.state;
    const { newPasswordAgain, isNewPasswordRepetitionValid } = this.state;
    return (
      <form ref={this.form} onSubmit={this.handleSubmit.bind(this)}>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-6">
            <div className="card card-w-title">
              <h2><b>Kennwort ändern</b></h2>
              <div className="p-grid form-group">
                <div className="p-col-12 p-md-12">
                  <span className="md-inputfield">
                    <Message
                      text='Ein gültiges Kennwort besteht aus mindestens 10 und maximal 20 Zeichen, wobei die Zeichen aus mindestens 3 der folgenden 4 Kategorien zu wählen sind: Kleinbuchstaben, Großbuchstaben, Zahlen, Sonderzeichen. Keines der Zeichen \ / : * " < > | darf enthalten sein.'
                    />
                    <div className="p-col-12">
                      <Messages
                        ref={(el) => { (this.messages = el); }}
                        style={{ marginBottom: '1em' }}
                      />
                    </div>
                  </span>
                </div>
                <div className="p-col-8 pi-md-8">
                  <span className="md-inputfield">
                    <Password
                      id="password"
                      name="password"
                      value={password}
                      onChange={(e) => this.handleChange(e)}
                      onKeyDown={(e) => this.handleKeyDown(e)}
                      autoFocus
                      tooltip="Geben Sie hier Ihr Kennwort ein."
                      tooltipOptions={{ event: 'focus' }}
                      feedback={false}
                    />
                    <label htmlFor="password">Altes Kennwort*</label>
                  </span>
                </div>
                <div className="p-col-8 pi-md-8">
                  <span className="md-inputfield">
                    <Password
                      id="newPassword"
                      name="newPassword"
                      value={newPassword}
                      onChange={(e) => this.handleNewPasswordChange(e)}
                      onKeyDown={(e) => this.handleKeyDown(e)}
                      tooltip="Geben Sie hier Ihr neues Kennwort ein."
                      tooltipOptions={{ event: 'focus' }}
                      feedback={false}
                    />
                    <label htmlFor="newPassword">Neues Kennwort*</label>
                    {!isNewPasswordValid && (
                      <small id="password-error" className="p-invalid" style={{ color: '#f44336', display: 'block', marginTop: '5px' }}>
                        Das Kennwort darf maximal 20 Zeichen lang sein und folgende Zeichen nicht enthalten: \ / : * " &lt; &gt; |
                      </small>
                    )}
                  </span>
                </div>
                <div className="p-col-8 pi-md-8">
                  <span className="md-inputfield">
                    <Password
                      id="newPasswordAgain"
                      name="newPasswordAgain"
                      value={newPasswordAgain}
                      onChange={(e) => this.handleNewPasswordRepetitionChange(e)}
                      onKeyDown={(e) => this.handleKeyDown(e)}
                      tooltip="Geben Sie hier Ihr neues Kennwort nochmals ein."
                      tooltipOptions={{ event: 'focus' }}
                      feedback={false}
                    />
                    <label htmlFor="newPasswordAgain">Neues Kennwort wiederholen*</label>
                    {!isNewPasswordRepetitionValid && (
                      <small id="password-error" className="p-invalid" style={{ color: '#f44336', display: 'block', marginTop: '5px' }}>
                        Das Kennwort darf maximal 20 Zeichen lang sein und folgende Zeichen nicht enthalten: \ / : * " &lt; &gt; |
                      </small>
                    )}
                  </span>
                </div>
                <div className="p-col-6">
                  <Button
                    type="submit"
                    id="save"
                    className={
                      this.validateForm()
                        ? 'p-button-success'
                        : 'p-button-primary'
                    }
                    label="Ändern"
                    icon="pi-md-check"
                    disabled={!this.validateForm()}
                    tooltip={
                      this.validateForm()
                        ? 'Klick oder Enter'
                        : 'Bitte füllen Sie alle mit * gekennzeichneten Pflichtfelder aus'
                    }
                    tooltipOptions={{ position: 'bottom' }}
                  />
                </div>
                <div className="p-col-12 p-md-6">
                  <span className="md-inputfield">
                    <span className="md-inputfield">
                      <Button
                        id="cancel"
                        icon="pi-md-cancel"
                        label="Abbrechen"
                        onClick={this.handleAbort}
                      />
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

ChangePassword.propTypes = {
  history: PropTypes.instanceOf(Object),
};

ChangePassword.defaultProps = {
  history: null,
};
